import { useState } from "react";
import { Button } from "react-bootstrap";
//comp
import ItemAddNav from "../navig/item/add/ItemAddNav";
import { BiAddToQueue } from "react-icons/bi";

//--------------------------------------------------------
export default function AddButton() {
    //hook
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    //view
    return (
        <>
            <Button
                style={{ marginRight: "10px" }}
                size="lg"
                variant="info"
                onClick={() => {
                    handleShow();
                }}
            >
                <BiAddToQueue />
            </Button>
            <ItemAddNav show={show} handleClose={handleClose} />
        </>
    );
}
